export function objectArrayMin(objArr, id) {
  if (objArr.length === 0) return 0;
  let min = objArr[0][id];
  for (let i = 0; i < objArr.length; i++) {
    if (objArr[i][id] < min) min = objArr[i][id];
  }
  return min;
}

export function objectArraySum(objArr, id) {
  if (objArr.length === 0) return 0;
  let sum = 0;
  for (let i = 0; i < objArr.length; i++) {
    sum += objArr[i][id];
  }
  return sum;
}

export function epsilonRound(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100
}
